// Import stylesheet
import '../sass/main.scss';

// Import polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './polyfills';
import '@stimulus/polyfills';
import 'whatwg-fetch';

import initializeForms from './initializers/forms';
import logPardotVisitor from './logPardotVisitor';
import logRAID from './logRAID';
import shareableLink from './components/shareableLink';
import startStimulus from './stimulusControllers';

const init = () => {
  if (window.hasOwnProperty('isAssetLoaded')) {
    return;
  }

  // Components
  shareableLink();

  // Controllers
  startStimulus();

  // Initializers
  initializeForms();

  // Logging for form handlers
  // This can be removed once we go to rs-com since this is built
  // into fw-pardot-scripts
  const hasIframe = document.querySelector('js-embeddedForm');
  if (!hasIframe) {
    logPardotVisitor();
    logRAID();
  }
};

init();
window.isAssetLoaded = true;
